module.exports = __webpack_public_path__ + "static/img/modal-complete.251f1e96.png";